(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[506],{

/***/ 50341:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[product]",
      function () {
        return __webpack_require__(38971);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 50569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "GN": function() { return /* binding */ addToCartWithPrice; },
  "o3": function() { return /* binding */ applyCouponToCart; },
  "DU": function() { return /* binding */ createGuestEmptyCart; },
  "XM": function() { return /* binding */ getCartDataFromServer; },
  "n2": function() { return /* binding */ loggedInUserCartId; },
  "Lw": function() { return /* binding */ mergeCarts; },
  "r$": function() { return /* binding */ removeCouponFromCart; },
  "Cn": function() { return /* binding */ removeItemFromCart; },
  "xu": function() { return /* binding */ updateCart; }
});

// UNUSED EXPORTS: addToCart

// EXTERNAL MODULE: ./graphqlClient.js
var graphqlClient = __webpack_require__(33119);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(31230);
// EXTERNAL MODULE: ./gql/common.js
var common = __webpack_require__(76708);
;// CONCATENATED MODULE: ./gql/cart/cart.gql.js

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\nquery($cartId: String!) {\n    cart(cart_id: $cartId) ",
        "\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\nquery GetCartId {\n  customerCart {\n    id\n  }\n}\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\nmutation CreateGuestCart {\n  createEmptyCart\n}\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation AddToCart($cartId: String!, $sku: String!, $quantity: Float!) {\n    addSimpleProductsToCart(\n      input: {\n        cart_id: $cartId\n        cart_items: [\n          {\n            data: {\n              quantity: $quantity\n              sku: $sku\n            }\n          }\n        ]\n      }\n    ) {\n      cart ",
        "\n    }\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation addSimpleProductsToCartCustomPrice($pincode: String!, $cartId: String!, $sku: String!, $quantity: Float!, $custom_price: Float!) {\n    addSimpleProductsToCartCustomPrice(\n      input: {\n        cart_id: $cartId\n        pincode: $pincode\n        cart_items: [\n          {\n              quantity: $quantity\n              sku: $sku\n              custom_price: $custom_price\n            \n          }\n        ]\n      }\n    )  ",
        "\n    \n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\nmutation RemoveItemFromCart($cartId: String!, $cartItemId: Int!) {\n  removeItemFromCart(\n    input: {\n      cart_id: $cartId,\n      cart_item_id: $cartItemId\n    }\n  ) {\n    cart ",
        "\n  }\n}\n\n\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation MergeCarts($sourceCartId: String!, $destinationCartId: String!) {\n    mergeCarts(sourceCartId: $sourceCartId, destinationCartId: $destinationCartId) {\n      id\n      items {\n        id\n        quantity\n      }\n    }\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "mutation($cartId: String!, $couponCode: String!) {\n  applyCouponToCart(\n    input: {\n      cart_id: $cartId\n      coupon_code: $couponCode\n    }\n  ) {\n    cart",
        "\n  }\n}\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation RemoveCouponFromCart($cartId: String!) {\n    removeCouponFromCart (\n      input:{ cart_id: $cartId }\n  ) \n  {\n     cart ",
        "\n  }\n}"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ($cartId: String!, $cartItems: [CartItemUpdateInput!]!) {\n    updateCartItems(\n      input: {\n        cart_id: $cartId\n        cart_items: $cartItems\n      }\n    ) {\n      cart ",
        "\n    }\n  }\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}


const CART_DATA = (0,lib/* gql */.Ps)(_templateObject(), common/* commonCart */.WU);
// export const GUEST_MINI_CART = gql`
// query($cartId: String!) {
//     cart(cart_id: $cartId) {
//       id
//       items {
//         id
//         quantity
//         product {
//           sku
//           name
//           price {
//             regularPrice {
//               amount {
//                 value
//                 currency
//               }
//             }
//           }
//         }
//       }
//       prices {
//         grand_total {
//           value
//           currency
//         }
//       }
//     }
//   }
// `;
// export const LOGGED_IN_USER_MINI_CART = gql`
// query($cartId: String!) {
//     cart(cart_id: $cartId) {
//       id
//       items {
//         id
//         quantity
//         product {
//           sku
//           name
//           price {
//             regularPrice {
//               amount {
//                 value
//                 currency
//               }
//             }
//           }
//         }
//       }
//       prices {
//         grand_total {
//           value
//           currency
//         }
//       }
//     }
//   }
// `;
const LOGGED_IN_USER_CART_ID = (0,lib/* gql */.Ps)(_templateObject1());
const CREATE_GUEST_EMPTY_CART = (0,lib/* gql */.Ps)(_templateObject2());
const cart_gql_ADD_TO_CART = (0,lib/* gql */.Ps)(_templateObject3(), common/* commonCart */.WU);
const ADD_TO_CART_WITH_CUSTOM_PRICE = (0,lib/* gql */.Ps)(_templateObject4(), common/* commonCart */.WU);
const REMOVE_ITEM_FORM_CART = (0,lib/* gql */.Ps)(_templateObject5(), common/* commonCart */.WU);
const MERGE_CARTS = (0,lib/* gql */.Ps)(_templateObject6());
const APPLY_COUPAN_TO_CART = (0,lib/* gql */.Ps)(_templateObject7(), common/* commonCart */.WU);
const REMOVE_COUPAN_FROM_CART = (0,lib/* gql */.Ps)(_templateObject8(), common/* commonCart */.WU);
const UPDATE_CART = (0,lib/* gql */.Ps)(_templateObject9(), common/* commonCart */.WU);
;

;// CONCATENATED MODULE: ./api.services.js/cart.js


const getCartDataFromServer = async (variables)=>{
    let options = {
        query: CART_DATA,
        variables: variables
    };
    if (variables === null || variables === void 0 ? void 0 : variables.token) {
        options = {
            ...options,
            context: {
                headers: {
                    Authorization: "Bearer ".concat(variables.token)
                }
            },
            fetchPolicy: "no-cache"
        };
    }
    try {
        const response = await graphqlClient/* default.query */.Z.query(options);
        return response;
    } catch (error) {
        return error;
    }
};
const addToCart = async (variables)=>{
    let options = {
        mutation: ADD_TO_CART,
        variables: variables
    };
    if (variables === null || variables === void 0 ? void 0 : variables.token) {
        options = {
            ...options,
            context: {
                headers: {
                    Authorization: "Bearer ".concat(variables.token)
                }
            },
            fetchPolicy: "no-cache"
        };
    }
    try {
        const response = await client.mutate(options);
        return response;
    } catch (error) {
        return error;
    }
};
const addToCartWithPrice = async (variables)=>{
    let options = {
        mutation: ADD_TO_CART_WITH_CUSTOM_PRICE,
        variables: variables
    };
    if (variables === null || variables === void 0 ? void 0 : variables.token) {
        options = {
            ...options,
            context: {
                headers: {
                    Authorization: "Bearer ".concat(variables.token)
                }
            },
            fetchPolicy: "no-cache"
        };
    }
    try {
        const response = await graphqlClient/* default.mutate */.Z.mutate(options);
        return response;
    } catch (error) {
        return error;
    }
};
const removeItemFromCart = async (variables)=>{
    let options = {
        mutation: REMOVE_ITEM_FORM_CART,
        variables: variables
    };
    if (variables === null || variables === void 0 ? void 0 : variables.token) {
        options = {
            ...options,
            context: {
                headers: {
                    Authorization: "Bearer ".concat(variables.token)
                }
            },
            fetchPolicy: "no-cache"
        };
    }
    try {
        const response = await graphqlClient/* default.mutate */.Z.mutate(options);
        return response;
    } catch (error) {
        return error;
    }
};
const createGuestEmptyCart = async (variables)=>{
    const options = {
        mutation: CREATE_GUEST_EMPTY_CART,
        variables: variables
    };
    try {
        const response = await graphqlClient/* default.mutate */.Z.mutate(options);
        return response;
    } catch (error) {
        return error;
    }
};
const loggedInUserCartId = async (variables)=>{
    const options = {
        query: LOGGED_IN_USER_CART_ID,
        variables: variables,
        context: {
            headers: {
                Authorization: "Bearer ".concat(variables.token)
            }
        }
    };
    try {
        const response = await graphqlClient/* default.query */.Z.query(options);
        return response;
    } catch (error) {
        return error;
    }
};
const mergeCarts = async (variables)=>{
    const options = {
        mutation: MERGE_CARTS,
        variables: variables,
        context: {
            headers: {
                Authorization: "Bearer ".concat(variables.token)
            }
        }
    };
    try {
        const response = await graphqlClient/* default.mutate */.Z.mutate(options);
        return response;
    } catch (error) {
        return error;
    }
};
const applyCouponToCart = async (variables)=>{
    let options = {
        mutation: APPLY_COUPAN_TO_CART,
        variables: variables
    };
    if (variables === null || variables === void 0 ? void 0 : variables.token) {
        options = {
            ...options,
            context: {
                headers: {
                    Authorization: "Bearer ".concat(variables.token)
                }
            }
        };
    }
    try {
        const response = await graphqlClient/* default.mutate */.Z.mutate(options);
        return response;
    } catch (error) {
        return error;
    }
};
const removeCouponFromCart = async (variables)=>{
    let options = {
        mutation: REMOVE_COUPAN_FROM_CART,
        variables: variables
    };
    if (variables === null || variables === void 0 ? void 0 : variables.token) {
        options = {
            ...options,
            context: {
                headers: {
                    Authorization: "Bearer ".concat(variables.token)
                }
            }
        };
    }
    try {
        const response = await graphqlClient/* default.mutate */.Z.mutate(options);
        return response;
    } catch (error) {
        return error;
    }
};
const updateCart = async (variables)=>{
    let options = {
        mutation: UPDATE_CART,
        variables: variables
    };
    if (variables === null || variables === void 0 ? void 0 : variables.token) {
        options = {
            ...options,
            context: {
                headers: {
                    Authorization: "Bearer ".concat(variables.token)
                }
            },
            fetchPolicy: "no-cache"
        };
    }
    try {
        const response = await graphqlClient/* default.mutate */.Z.mutate(options);
        return response;
    } catch (error) {
        return error;
    }
};


/***/ }),

/***/ 57891:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_i": function() { return /* binding */ addProductReview; },
  "Wt": function() { return /* binding */ userReviewDetail; },
  "LK": function() { return /* binding */ userReviews; }
});

// EXTERNAL MODULE: ./graphqlClient.js
var graphqlClient = __webpack_require__(33119);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(31230);
;// CONCATENATED MODULE: ./gql/reviews/reviews.gql.js

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\nquery customer_review_list {\n  customer_review_list{\n      customer{\n          firstname\n          lastname\n          email\n      }\n      reviews{\n          id\n          title\n          detail\n          rating\n          percentage\n          created_at\n          product{\n              id\n              name\n              url\n          }\n      }\n  }\n}\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query customer_review_list($reviewId: Int!) {\n    customer_review_view(review_id: $reviewId) {\n      reviews {\n        id\n        title\n        detail\n        rating\n        percentage\n        created_at\n        rating_summary {\n          rating_count\n          avg_rating\n          avg_percentage\n        }\n        product {\n          id\n          name\n          url\n          image_url\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\nmutation ($entityPkValue: String!, $entityType: String!, $nickname: String!, $title: String!, $detail: String!, $ratingId: Int!, $value: Int!, $imageName: String!, $imageFile: String!) {\n  submitReview(input: {\n    entity_pk_value: $entityPkValue\n    entity_type: $entityType\n    nickname: $nickname\n    title: $title\n    detail: $detail\n    ratings: {\n      rating_id: $ratingId\n      value: $value\n    }\n    images: [\n      {\n        name: $imageName\n        file: $imageFile\n      }\n    ]\n  }) {\n    message\n    review_id\n  }\n}\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}

const GET_USER_REVIEWS = (0,lib/* gql */.Ps)(_templateObject());
const GET_USER_REVIEWS_DETAIL = (0,lib/* gql */.Ps)(_templateObject1());
const ADD_PRODUCT_REVIEW = (0,lib/* gql */.Ps)(_templateObject2());

;// CONCATENATED MODULE: ./api.services.js/reviews.js


let userReviews = async (variables)=>{
    let options = {
        query: GET_USER_REVIEWS,
        variables: variables,
        context: {
            headers: {
                Authorization: "Bearer ".concat(variables.token)
            }
        }
    };
    try {
        let response = await graphqlClient/* default.query */.Z.query(options);
        return response;
    } catch (error) {
        return error;
    }
};
let addProductReview = async (variables)=>{
    let options = {
        mutation: ADD_PRODUCT_REVIEW,
        variables: variables
    };
    if (variables === null || variables === void 0 ? void 0 : variables.token) {
        options = {
            ...options,
            context: {
                headers: {
                    Authorization: "Bearer ".concat(variables.token)
                }
            }
        };
    }
    try {
        let response = await graphqlClient/* default.mutate */.Z.mutate(options);
        return response;
    } catch (error) {
        return error;
    }
};
let userReviewDetail = async (variables)=>{
    let options = {
        query: GET_USER_REVIEWS_DETAIL,
        variables: variables,
        context: {
            headers: {
                Authorization: "Bearer ".concat(variables.token)
            }
        }
    };
    try {
        let response = await graphqlClient/* default.query */.Z.query(options);
        return response;
    } catch (error) {
        return error;
    }
};


/***/ }),

/***/ 76708:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
const _jsxRuntime = __webpack_require__(85893);
module.exports.WU = "{\n    id\n    pincode\n    prices {\n      grand_total {\n        value\n        currency\n      }\n      subtotal_including_tax {\n        value\n        currency\n      }\n      discount {\n        amount {\n          value\n          currency\n        }\n      }\n    }\n    items {\n      uid\n      id\n      quantity\n      prices {\n        total_item_discount {\n          value\n          currency\n        }\n        row_total {\n          value\n          currency\n        }\n        price {\n          value\n          currency\n        }\n        discounts {\n          label\n          amount {\n            value\n            currency\n          }\n        }\n      }\n      product {\n        sku\n        name\n        image {\n          url\n          label\n        }\n        price {\n          regularPrice {\n            amount {\n              value\n              currency\n            }\n          }\n        }\n      }\n    }\n   applied_coupons {\n    code\n  }\n  email\n  billing_address {\n    firstname\n    lastname\n    company\n    street\n    city\n    region{\n      code\n      label\n    }\n    postcode\n    telephone\n    country{\n      code\n      label\n    }\n  }\n  shipping_addresses {\n    firstname\n    lastname\n    company\n    street\n    city\n    region {\n      code\n      label\n    }\n    postcode\n    telephone\n    country {\n      code\n      label\n    }\n    available_shipping_methods{\n      carrier_code\n      carrier_title\n      method_code\n      method_title\n      amount {\n        value\n        currency\n      }\n    }\n      selected_shipping_method {\n        carrier_code\n        carrier_title\n        method_code\n        method_title\n        amount {\n          value\n          currency\n        }\n      }\n    }\n    available_payment_methods {\n      code\n      title\n    }\n    selected_payment_method {\n      code\n    }\n  }\n  ";
module.exports.Kn = (address)=>{
    if (!address) {
        return;
    }
    let addr = [];
    if (address.street) {
        addr.push(address.street);
    }
    if (address.city) {
        addr.push(address.city);
    }
    if (address.region) {
        addr.push(address.region.region);
    }
    if (address.postcode) {
        addr.push(address.postcode);
    }
    if (address.country_code) {
        addr.push(address.country.code);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
        children: addr.join(", ")
    });
};
module.exports.LJ = (address)=>{
    if (!address) {
        return;
    }
    let addr = [];
    if (address.street) {
        addr.push(address.street);
    }
    if (address.city) {
        addr.push(address.city);
    }
    if (address.region) {
        addr.push(address.region.region);
    }
    if (address.postcode) {
        addr.push(address.postcode);
    }
    if (address.country_code) {
        addr.push(address.country.code);
    }
    return addr.join(", ");
};


/***/ }),

/***/ 38971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _product_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@fireworks-js/react/dist/index.es.js + 1 modules
var index_es = __webpack_require__(66706);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 40 modules
var axios = __webpack_require__(6154);
// EXTERNAL MODULE: ./node_modules/crypto-js/index.js
var crypto_js = __webpack_require__(81354);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Accordion.js + 7 modules
var Accordion = __webpack_require__(5607);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Breadcrumb.js
var Breadcrumb = __webpack_require__(52681);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Form.js + 10 modules
var Form = __webpack_require__(4492);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/InputGroup.js
var InputGroup = __webpack_require__(62318);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Modal.js + 6 modules
var Modal = __webpack_require__(6212);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Spinner.js
var Spinner = __webpack_require__(36968);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(89583);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/react-stars/dist/react-stars.js
var react_stars = __webpack_require__(40765);
// EXTERNAL MODULE: ./node_modules/react-web-share/dist/esm/index.js
var esm = __webpack_require__(80521);
// EXTERNAL MODULE: ./node_modules/sweetalert/dist/sweetalert.min.js
var sweetalert_min = __webpack_require__(46737);
var sweetalert_min_default = /*#__PURE__*/__webpack_require__.n(sweetalert_min);
// EXTERNAL MODULE: ./api.services.js/cart.js + 1 modules
var cart = __webpack_require__(50569);
// EXTERNAL MODULE: ./api.services.js/others.js + 2 modules
var others = __webpack_require__(63372);
// EXTERNAL MODULE: ./config.js
var config = __webpack_require__(83346);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/FloatingLabel.js
var FloatingLabel = __webpack_require__(74119);
// EXTERNAL MODULE: ./api.services.js/reviews.js + 1 modules
var reviews = __webpack_require__(57891);
// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__(19755);
;// CONCATENATED MODULE: ./src/components/addReview.js








// mutation ($entityPkValue: String!, $entityType: String!, $nickname: String!, $title: String!, $detail: String!, $ratingId: Int!, $value: Int!, $imageName: String!, $imageFile: String!) {
function AddReviews(props) {
    const [file, setFile] = (0,react.useState)("");
    const [name, setName] = (0,react.useState)("");
    const [review, setReview] = (0,react.useState)("");
    const [rating, setRating] = (0,react.useState)(0);
    const [error, setError] = (0,react.useState)("");
    const [submitting, setSubmitting] = (0,react.useState)(false);
    const ratingChanged = (newRating)=>{
        setRating(newRating);
    };
    const addReview = async (event)=>{
        setError("");
        event.preventDefault();
        if (!name) {
            setError("Name is required.");
            return;
        }
        if (!review) {
            setError("Review is required.");
            return;
        }
        setSubmitting(true);
        let obj = {
            entityPkValue: props.productId,
            entityType: "product",
            nickname: name,
            title: review,
            detail: review,
            ratingId: 1,
            value: rating,
            imageName: "",
            imageFile: ""
        };
        if (localStorage.getItem("userToken")) {
            obj = {
                ...obj,
                token: AES.decrypt(localStorage.getItem("userToken"), "wqeetdrcgfyt6rfychgvhy78t67gvjbhu89y78tgu909iuygcvbnjmkhuyghbvnkjiougyhbvjnmkloipughbj").toString()
            };
        }
        if (file) {
            const reader = new FileReader();
            reader.onloadend = async function() {
                obj = {
                    ...obj,
                    imageName: file.name,
                    imageFile: reader.result.split(",")[1]
                };
                let response = await (0,reviews/* addProductReview */._i)(obj);
                if (response.data.submitReview.message) {
                    swal("".concat(response.data.submitReview.message));
                    setSubmitting(false);
                }
            };
            reader.readAsDataURL(file);
        } else {
            let response = await (0,reviews/* addProductReview */._i)(obj);
            if (response.data.submitReview.message) {
                swal("".concat(response.data.submitReview.message));
                setSubmitting(false);
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default */.Z, {
        onSubmit: (e)=>addReview(e),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "your_rating_css_div flex-css",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-3 your_rating_css",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Your Rating"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stars/* default */.Z, {
                                count: 5,
                                value: rating,
                                onChange: ratingChanged,
                                edit: true,
                                color2: "#ff5e00"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Group */.Z.Group, {
                        className: "mb-3",
                        controlId: "formBasicEmail",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                            type: "text",
                            placeholder: "Name",
                            value: name,
                            onChange: (e)=>setName(e.target.value)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingLabel/* default */.Z, {
                controlId: "floatingTextarea2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                    as: "textarea",
                    placeholder: "Your Message",
                    style: {
                        height: "150px"
                    },
                    value: review,
                    onChange: (e)=>setReview(e.target.value)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "review_pro_custom_file flex-css",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                for: "upload-photo",
                                children: "+ Add Review Images"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "file",
                                name: "photo",
                                id: "upload-photo",
                                onChange: (e)=>setFile(e.target.files[0])
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "primary",
                        type: "Submit Review",
                        onClick: addReview,
                        disabled: submitting,
                        children: submitting ? "Submitting" : "Submit Review"
                    }),
                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "error text-danger",
                        children: error
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var addReview = (AddReviews);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@apollo/client/node_modules/graphql-tag/lib/index.js
var graphql_tag_lib = __webpack_require__(76661);
// EXTERNAL MODULE: ./graphqlClient.js
var graphqlClient = __webpack_require__(33119);
;// CONCATENATED MODULE: ./src/components/customerReview.js

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        '\n            {\n              cmsBlocks(identifiers: ["home_testimonials"]) {\n                items {\n                  identifier\n                  title\n                  content\n                }\n              }\n            }\n          '
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}





const CustomerReview = ()=>{
    const [imageSources, setImageSources] = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        const fetchData = async ()=>{
            try {
                const { data  } = await graphqlClient/* default.query */.Z.query({
                    query: (0,graphql_tag_lib/* gql */.Ps)(_templateObject())
                });
                const html = data.cmsBlocks.items[0].content;
                const tempElement = document.createElement("div");
                tempElement.innerHTML = html;
                const customerCols = tempElement.querySelectorAll(".review-row");
                const sources = Array.from(customerCols).map((col)=>{
                    const content = col.querySelector(".review-text p").textContent;
                    const name = col.querySelector(".author-bx h6").textContent;
                    return {
                        content,
                        name
                    };
                });
                setImageSources(sources);
            } catch (error) {
                console.log("Error fetching data:", error);
            }
        };
        fetchData();
    }, []);
    const settings2 = {
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        centerMode: true,
        autoplaySpeed: 3000,
        arrows: true,
        dots: false,
        centerPadding: "0px",
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    arrows: true,
                    dots: false,
                    centerMode: true,
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 575,
                settings: {
                    arrows: true,
                    dots: false,
                    centerMode: true,
                    slidesToShow: 1
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (imageSources === null || imageSources === void 0 ? void 0 : imageSources.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "home_testimonials testimonials-section pro_testimonials",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "productpage_title",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "What do our customers say..."
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                    ...settings2,
                    className: "home_testimonials",
                    children: imageSources.map((cur, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "review-row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "quote-bx",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "../abddd.jpg",
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "review-text",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: cur.content
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "author-bx",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                        children: cur.name
                                    })
                                })
                            ]
                        }, index))
                })
            ]
        })
    });
};
/* harmony default export */ var customerReview = (CustomerReview);

// EXTERNAL MODULE: ./src/components/loader.js
var loader = __webpack_require__(62077);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./src/utils/convertPricePerSqmToSqFt.js
var convertPricePerSqmToSqFt = __webpack_require__(35620);
;// CONCATENATED MODULE: ./src/UnbxdProductCardlike.js









const UnbxdProductCardlike = (props)=>{
    var ref;
    let [mrp, setMrp] = (0,react.useState)(0);
    let [sellingPrice, seSellingPrice] = (0,react.useState)(0);
    let [outOfStock, setOutOfStock] = (0,react.useState)("Add to cart");
    const [AvailableStock, setAvailableStock] = (0,react.useState)(0);
    const getBestPrice = async (pin)=>{
        var ref, ref1, ref2, ref3;
        let apiresult = await axios/* default.get */.Z.get("https://obl-js.orientbell.com/api/product-availability-dev?sku=".concat(props.product.sku, "&pincode=").concat(pin, "&factory=").concat(props.product.tileFactoryProduction));
        if (((ref = apiresult.data) === null || ref === void 0 ? void 0 : (ref1 = ref.Plants) === null || ref1 === void 0 ? void 0 : ref1.length) > 0) {
            var ref4, ref5, ref6, ref7;
            let temparr = [];
            if (((ref4 = apiresult.data) === null || ref4 === void 0 ? void 0 : ref4.Plants.includes("Sikandrabad Plant")) && props.product.skdStock) {
                temparr.push(Number(props.product.skdStock));
            }
            if (((ref5 = apiresult.data) === null || ref5 === void 0 ? void 0 : ref5.Plants.includes("Dora Plant")) && props.product.doraStock) {
                temparr.push(Number(props.product.doraStock));
            }
            if (((ref6 = apiresult.data) === null || ref6 === void 0 ? void 0 : ref6.Plants.includes("Hoskote Plant")) && props.product.hoskoteStock) {
                temparr.push(Number(props.product.hoskoteStock));
            }
            if (((ref7 = apiresult.data) === null || ref7 === void 0 ? void 0 : ref7.Plants.includes("West Zone")) && props.product.westZoneStock) {
                temparr.push(Number(props.product.westZoneStock));
            }
            setAvailableStock(temparr.reduce((total, obj)=>total + obj, 0));
        } else {
            setAvailableStock("Not Deliverable");
        }
        if (((ref2 = apiresult.data) === null || ref2 === void 0 ? void 0 : ref2.transportOrder) == 0) {
            return;
        } else if ((ref3 = apiresult.data) === null || ref3 === void 0 ? void 0 : ref3.devliverytime) {
            var ref8;
            if ((ref8 = apiresult.data) === null || ref8 === void 0 ? void 0 : ref8.updated_price_ft) {
                var ref9;
                seSellingPrice((ref9 = apiresult.data) === null || ref9 === void 0 ? void 0 : ref9.updated_price_ft);
            }
        } else if (1 > apiresult.data.availableQty) {
            setOutOfStock("Out of Stock");
        } else if (apiresult.data.addesses == "" || !apiresult.data.devliverytime) {
            setOutOfStock("Not Deliverable in your Area");
        }
    };
    const handleOnClick = (Urll)=>{
        var payload = {
            pid: props.product.uniqueId,
            prank: props.prank,
            experience_pagetype: "Product",
            experience_widget: props.widget,
            requestId: props.UnbxdRecomendatoRequestID
        };
        let UnbxdVistType = js_cookie/* default.get */.Z.get("unbxd.visit");
        let UnbxdVistID = js_cookie/* default.get */.Z.get("unbxd.visitId");
        let UnbxdUserID = js_cookie/* default.get */.Z.get("unbxd.userId");
        let UnbxdApiKey = "ss-unbxd-aapac-prod-orientbell53741713874410";
        axios/* default.get */.Z.get(new URL("https://tracker.unbxdapi.com/v2/1p.jpg?data=".concat(encodeURIComponent(JSON.stringify({
            pid: props.product.uniqueId,
            pr: "",
            experience_pagetype: "PRODUCT",
            experience_widget: props.widget,
            requestId: props.UnbxdRecomendatoRequestID,
            url: "https://staging.orientbell.com",
            referrer: "",
            visit_type: UnbxdVistType,
            ver: "4.0.28",
            _uf: 1187461382,
            visitId: UnbxdVistID
        })), "&UnbxdKey=").concat(encodeURIComponent(UnbxdApiKey), "&action=click&uid=").concat(encodeURIComponent(UnbxdUserID))).toString());
        // if(typeof Unbxds !== 'undefined' && Unbxd && typeof Unbxd.track === 'function') {
        //   Unbxd.track('click', payload)
        // } else {
        //   console.log('unbxdAnalytics.js is not loaded!')
        // }
        window.location = Urll;
    };
    (0,react.useEffect)(()=>{
        if (js_cookie/* default.get */.Z.get("pincode")) {
        // getBestPrice(cookie.get('pincode'))
        }
        setMrp((0,convertPricePerSqmToSqFt/* default */.Z)(props.product.MRP ? props.product.MRP : props.product.price));
        setAvailableStock([
            props.product.hoskoteStock,
            props.product.westZoneStock,
            props.product.doraStock,
            props.product.skdStock
        ].filter((cc)=>cc).reduce((total, obj)=>total + Number(obj), 0));
    }, [
        props
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "obl-searchresult-col",
            id: props.product.uniqueId,
            style: {
                width: "100%"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    class: "cate-pro-figure",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        onClick: (e)=>{
                            e.preventDefault();
                            handleOnClick(props.product.productUrl.replace("https://server.orientbell.com/", "/"));
                        },
                        href: props.product.productUrl.replace("https://server.orientbell.com/", "/"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: ((ref = props.product.imageUrl) === null || ref === void 0 ? void 0 : ref.length) ? props.product.imageUrl[0] : ""
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    class: "cate-pro-text",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            class: "simi-name",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                onClick: (e)=>{
                                    e.preventDefault();
                                    handleOnClick(props.product.productUrl.replace("https://server.orientbell.com/", "/"));
                                },
                                href: props.product.productUrl.replace("https://server.orientbell.com/", "/"),
                                children: props.product.title
                            })
                        }),
                        sellingPrice && Number(mrp) > Number(sellingPrice) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mrp",
                            children: [
                                "Offer price ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "₹."
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    style: {
                                        textDecoration: "line-through",
                                        marginRight: "5px"
                                    },
                                    children: [
                                        " ",
                                        Math.round(mrp),
                                        " "
                                    ]
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                    children: [
                                        " ",
                                        Math.round(sellingPrice),
                                        " /- Sq.ft "
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mrp",
                            children: [
                                "MRP ",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                    children: [
                                        " ₹ ",
                                        Math.round(mrp),
                                        " /- Sq.ft"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            class: "produ-size"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            class: "add-button",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                onClick: (e)=>{
                                    e.preventDefault();
                                    handleOnClick(props.product.productUrl.replace("https://server.orientbell.com/", "/"));
                                },
                                href: "".concat(props.product.productUrl.replace("https://server.orientbell.com/", "/")),
                                className: "add-pro-btn",
                                style: {
                                    backgroundColor: outOfStock == "Not Deliverable in your Area" ? "#a5a5a5" : outOfStock == "Out of Stock" ? "#ffcb08" : "#0b9444"
                                },
                                children: outOfStock
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var src_UnbxdProductCardlike = (UnbxdProductCardlike);

;// CONCATENATED MODULE: ./src/components/product/youMayAlso.js




function YouMayAlsoLike(props) {
    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
        ...settings,
        children: props.products.map((prod, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(src_UnbxdProductCardlike, {
                product: prod,
                UnbxdRecomendatoRequestID: props.UnbxdRecomendatoRequestID,
                widget: props.widget,
                prank: index + 1
            }, index))
    });
}
/* harmony default export */ var youMayAlso = (YouMayAlsoLike);

// EXTERNAL MODULE: ./node_modules/react-use/lib/useWindowSize.js
var useWindowSize = __webpack_require__(62964);
;// CONCATENATED MODULE: ./pages/[product].js































const Product = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29;
    const router = (0,next_router.useRouter)();
    if (props.display404) router.push("/404");
    if (!(props === null || props === void 0 ? void 0 : (ref = props.getProductSetail) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.products) === null || ref2 === void 0 ? void 0 : ref2.items[0]) && !props.display404) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                            children: router.asPath.replace("/", "").split("-").join(" ")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "twitter:title",
                            content: router.asPath.replace("/", "").split("-").join(" ")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            itemprop: "name",
                            content: router.asPath.replace("/", "").split("-").join(" ")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:title",
                            content: router.asPath.replace("/", "").split("-").join(" ")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "description",
                            content: "Orient Bell Limited (OBL) is amongst the largest manufacturers of Wall and Floor Tiles. Established in 1977, OBL has been a pioneer in the Industry with a focus"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            itemprop: "bookFormat",
                            content: "EBook"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "twitter:card",
                            content: "summary_large_image"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "twitter:image:src",
                            content: "files/assets/html/skin/images/fbThumb.jpg"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:type",
                            content: "article"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "image",
                            property: "og:image",
                            content: "files/assets/html/skin/images/fbThumb.jpg"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:image:type",
                            content: "image/jpeg"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:article:section",
                            content: "Article Section"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                    src: "".concat(config/* default.API_ENDPOINT */.Z.API_ENDPOINT, "/").concat(router.query.product),
                    title: "".concat(router.query.product),
                    height: "600px",
                    width: "100%"
                })
            ]
        });
    }
    const [product, setProduct] = (0,react.useState)(props.getProductSetail.data.products.items[0]);
    const [productImg, setProductImg] = (0,react.useState)((ref3 = props.getProductSetail.data.products.items[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.image) === null || ref4 === void 0 ? void 0 : ref4.url);
    const [reviews, setReviews] = (0,react.useState)(props.reviews);
    const [sellingPrice, setSellingPrice] = (0,react.useState)("");
    const [mrp, setMrp] = (0,react.useState)("");
    const [box, setBox] = (0,react.useState)(1);
    const [SqFt, setSqFt] = (0,react.useState)("");
    const [SqFtPerBox, setSqFtPerBox] = (0,react.useState)("");
    const [totalSellingPrice, setTotalSellingPrice] = (0,react.useState)("");
    const [totalMrpPrice, setTotalMrpPrice] = (0,react.useState)("");
    const [deliveryDate, setDeliveryDate] = (0,react.useState)("");
    const [Loading, setLoading] = (0,react.useState)(false);
    const [isModalOpen, setIsModalOpen] = (0,react.useState)(false);
    const [pincode, setPincode] = (0,react.useState)("");
    const [checkAviabilty, setCheckAviabilty] = (0,react.useState)(true);
    const [selectedSeze, setSelectedSeze] = (0,react.useState)("FT");
    const [updated_price_ft, setupdated_price_ft] = (0,react.useState)("");
    const [viewCount, setViewCount] = (0,react.useState)("");
    const [transportValue, settransportValue] = (0,react.useState)("");
    const [getInTouch, setGetInTouch] = (0,react.useState)(false);
    const [AvailableStock, setAvailableStock] = (0,react.useState)(0);
    const [ERPAvailableStock, setERPAvailableStock] = (0,react.useState)(!props.display404 ? [
        Number(product.extraVariables.skd_stock),
        Number(product.extraVariables.dora_stock),
        Number(product.extraVariables.hoskote_stock),
        Number(product.extraVariables.west_zone_stock)
    ].reduce((total, obj)=>total + obj, 0) : 0);
    const [similertiles, setsimilertiles] = (0,react.useState)([]);
    const [youmayalsolikee, setyoumayalsolikee] = (0,react.useState)([]);
    const { width , height  } = (0,useWindowSize/* default */.Z)();
    const [throwConfetti, setThrowConfetti] = (0,react.useState)(false);
    const [UnbxdRecomendatoRequestID, setUnbxdRecomendatoRequestID] = (0,react.useState)("");
    const [touch, setTouch] = (0,react.useState)({
        name: "",
        number: ""
    });
    const [videoURL, setvideoURL] = (0,react.useState)("");
    // const getProductReviews = async ()=>{
    //    let response = await productReviews({ urlKey:router.query.product}
    //    )
    //    setReviews(response.data.product_reviews.customer_review)
    // }
    const getYouMayAlsoLike = async (sku)=>{
        let response = await axios/* default.get */.Z.get("https://apac-recommendations.unbxd.io/v3.0/5a4b9251b67027ff94d260e4ac6ac09e/ss-unbxd-aapac-dev-orientbell53741713874300/recommendation?pageType=PRODUCT&id=".concat(sku, "&uid=").concat(js_cookie/* default.get */.Z.get("unbxd.userId"), "&ip=%3Cip%3E"));
        if (response.status == 200) {
            let arr = response.data.response.widgets.filter((cc)=>cc.widgetId == "widget3").length ? response.data.response.widgets.filter((cc)=>cc.widgetId == "widget3")[0].recommendations : [];
            let arr2 = response.data.response.widgets.filter((cc)=>cc.widgetId == "widget1").length ? response.data.response.widgets.filter((cc)=>cc.widgetId == "widget1")[0].recommendations : [];
            const unbxdRequestId = response.headers.get("unbxd-request-id");
            let UnbxdVistType = js_cookie/* default.get */.Z.get("unbxd.visit");
            let UnbxdVistID = js_cookie/* default.get */.Z.get("unbxd.visitId");
            let UnbxdUserID = js_cookie/* default.get */.Z.get("unbxd.userId");
            let UnbxdApiKey = "ss-unbxd-aapac-prod-orientbell53741713874410";
            setUnbxdRecomendatoRequestID(unbxdRequestId);
            //   var payload = {
            //    requestId: unbxdRequestId,
            //    pids_list: arr.map((cc)=>cc.uniqueId),
            //    experience_pagetype: 'Product',
            //    experience_widget: 'widget3'
            // }
            // "visit_type":"${UnbxdVistType}","visitId":"${UnbxdVistID}"&UnbxdKey="${UnbxdApiKey}"&action=experience_impression&uid="${UnbxdUserID}"`).toString())
            // axios.get(new URL(`https://tracker.unbxdapi.com/v2/1p.jpg?data={"experience_pagetype":"PRODUCT","experience_widget":"WIDGET3","pids_list":${arr.map((cc)=>`"${cc.uniqueId}"`)},"url":"https://staging.orientbell.com","referrer":"","requestId":"${unbxdRequestId}","visit_type":"${UnbxdVistType}","visitId":"${UnbxdVistID}"}&UnbxdKey="${UnbxdApiKey}"&action=experience_impression&uid="${UnbxdUserID}"`).toString())
            // axios.get(`https://tracker.unbxdapi.com/v2/1p.jpg?data={"experience_pagetype":"PRODUCT","experience_widget":"WIDGET3","pids_list":${arr.map((cc)=>`"${cc.uniqueId}"`)},"url":"https://staging.orientbell.com","referrer":"","requestId":"${unbxdRequestId}","visit_type":"${UnbxdVistType}","visitId":"${UnbxdVistID}"}&UnbxdKey="${UnbxdApiKey}"&action=experience_impression&uid="${UnbxdUserID}"`)
            axios/* default.get */.Z.get(new URL("https://tracker.unbxdapi.com/v2/1p.jpg?data=".concat(encodeURIComponent(JSON.stringify({
                experience_pagetype: "PRODUCT",
                experience_widget: "WIDGET3",
                pids_list: arr.map((cc)=>cc.uniqueId),
                url: "https://staging.orientbell.com",
                referrer: "",
                requestId: unbxdRequestId,
                visit_type: UnbxdVistType,
                visitId: UnbxdVistID
            })), "&UnbxdKey=").concat(encodeURIComponent(UnbxdApiKey), "&action=experience_impression&uid=").concat(encodeURIComponent(UnbxdUserID))).toString());
            axios/* default.get */.Z.get(new URL("https://tracker.unbxdapi.com/v2/1p.jpg?data=".concat(encodeURIComponent(JSON.stringify({
                experience_pagetype: "PRODUCT",
                experience_widget: "WIDGET1",
                pids_list: arr2.map((cc)=>cc.uniqueId),
                url: "https://staging.orientbell.com",
                referrer: "",
                requestId: unbxdRequestId,
                visit_type: UnbxdVistType,
                visitId: UnbxdVistID
            })), "&UnbxdKey=").concat(encodeURIComponent(UnbxdApiKey), "&action=experience_impression&uid=").concat(encodeURIComponent(UnbxdUserID))).toString());
            // var payload1 = {
            //    requestId: unbxdRequestId,
            //    pids_list: arr2.map((cc)=>cc.uniqueId),
            //    experience_pagetype: 'Product',
            //    experience_widget: 'widget1'
            // }
            // var action = 'experience_impression'
            // if(typeof Unbxd !== 'undefined' && Unbxd && typeof Unbxd.track === 'function') {
            //     Unbxd.track(action, payload)
            //     Unbxd.track(action, payload1)
            //    } else {
            //       console.log('unbxdAnalytics.js is not loaded!')
            //    }
            setsimilertiles(arr);
            setyoumayalsolikee(arr2);
        }
    };
    const getProdVideo = async (sku)=>{
        try {
            let response = await axios/* default.get */.Z.get("https://obl-js.orientbell.com/getProdVideo?erp=".concat(sku));
            if (response.status == 200) {
                var ref;
                if ((response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.status) == "sucsess") {
                    setvideoURL(response.data.link);
                } else {
                    return;
                }
            }
        } catch (error) {
            return;
        }
    };
    const getLoggedInUserCart = async ()=>{
        if (localStorage.getItem("userToken")) {
            const token = crypto_js.AES.decrypt(cartId.data.customerCart.id, "wqeetdrcgfyt6rfychgvhy78t67gvjbhu89y78tgu909iuygcvbnjmkhuyghbvnkjiougyhbvjnmkloipughbj").toString();
            let cartId = await (0,cart/* loggedInUserCartId */.n2)({
                token: token
            });
            localStorage.setItem("cartId");
        }
    };
    (0,react.useEffect)(()=>{
        if (!props.display404) {
            setAvailableStock([
                Number(product.extraVariables.skd_stock),
                Number(product.extraVariables.dora_stock),
                Number(product.extraVariables.hoskote_stock),
                Number(product.extraVariables.west_zone_stock)
            ].reduce((total, obj)=>total + obj, 0));
            setSqFt(Number(product.extraVariables.total_area_sq_ft).toFixed(2));
            setSqFtPerBox(product.extraVariables.total_area_sq_ft);
            setMrp(Math.round(Number(product.extraVariables.total_area_sq_ft) * Number(product.extraVariables.sq_ft_price)));
            setTotalMrpPrice(Number(product.extraVariables.total_area_sq_ft) * Number(product.extraVariables.sq_ft_price));
            setSellingPrice(Math.round(Number(product.extraVariables.total_area_sq_ft) * (Number(product.extraVariables.sq_ft_price) - Number(product.extraVariables.discounted_price))));
            setTotalSellingPrice(Number(product.extraVariables.total_area_sq_ft) * (Number(product.extraVariables.sq_ft_price) - Number(product.extraVariables.discounted_price)));
            // getProductReviews()
            getLoggedInUserCart();
            if (js_cookie/* default.get */.Z.get("pincode")) {
                getBestPrice(js_cookie/* default.get */.Z.get("pincode"), product.extraVariables.factory);
                setPincode(Number(js_cookie/* default.get */.Z.get("pincode")));
            }
            // console.log("8888", product)
            setViewCount(product.extraVariables.view_count);
            getProdVideo(product.sku);
            getYouMayAlsoLike(product.sku);
            var Unbxdpayload = {
                pid: product.sku,
                variantId: ""
            };
            if (typeof Unbxd !== "undefined" && Unbxd && typeof Unbxd.track === "function") {
                Unbxd.track("product_view", Unbxdpayload);
            } else {
                console.log("unbxdAnalytics.js is not loaded!");
            }
        } else {
            getYouMayAlsoLike(props.display404);
        }
    }, []);
    const handleSqFtChange = (e)=>{
        if (e.target.value > 0) {
            let box = e.target.value / SqFtPerBox;
            setSqFt(e.target.value);
            setTotalMrpPrice(mrp * Math.ceil(box));
            setTotalSellingPrice(sellingPrice * Math.ceil(box));
            setBox(Math.ceil(box));
        } else {
            setSqFt(e.target.value);
            setTotalMrpPrice(mrp * 1);
            setTotalSellingPrice(sellingPrice * 1);
        }
    };
    const handlePlusBox = ()=>{
        let tBox = box + 1;
        setSqFt((tBox * SqFtPerBox).toFixed(2));
        setTotalMrpPrice(mrp * tBox);
        setTotalSellingPrice(sellingPrice * tBox);
        setBox(tBox);
    };
    const handleMinusBox = ()=>{
        if (box > 1) {
            let tBox = box - 1;
            setSqFt((tBox * SqFtPerBox).toFixed(2));
            setTotalMrpPrice(mrp * tBox);
            setTotalSellingPrice(sellingPrice * tBox);
            setBox(tBox);
        }
    };
    const addProductToCart = async (type)=>{
        if (!deliveryDate) {
            sweetalert_min_default()("Please enter your pincode to add items in cart");
            return;
        }
        let UnbxdVistType = js_cookie/* default.get */.Z.get("unbxd.visit");
        let UnbxdUserID = js_cookie/* default.get */.Z.get("unbxd.userId");
        const token = crypto_js.AES.decrypt(localStorage.getItem("userToken"), "wqeetdrcgfyt6rfychgvhy78t67gvjbhu89y78tgu909iuygcvbnjmkhuyghbvnkjiougyhbvjnmkloipughbj").toString();
        let UnbxdApiKey = "ss-unbxd-aapac-prod-orientbell53741713874410";
        if (localStorage.getItem("cartId")) {
            var Unbxdpayload2 = {
                pid: product.sku,
                variantId: ""
            };
            //Commenting CART CALL as aksed by Vineela
            //         if(typeof Unbxd !== 'undefined' && Unbxd && typeof Unbxd.track === 'function') {
            //    // Unbxd.track('addToCart', Unbxdpayload2)
            //    axios.get(
            //       new URL(
            //         `https://tracker.unbxdapi.com/v2/1p.jpg?data=${encodeURIComponent(
            //           JSON.stringify({
            //             pid: product.sku,
            //             qty: box,
            //             variantId: "",
            //             url: "https://staging.orientbell.com",
            //             referrer: "",
            //             visit_type: UnbxdVistType,
            //             requestId: UnbxdRecomendatoRequestID,
            //           })
            //         )}&UnbxdKey=${encodeURIComponent(UnbxdApiKey)}&action=cart&uid=${encodeURIComponent(UnbxdUserID)}`
            //       ).toString()
            //     );
            //  } else {
            //    console.log('unbxdAnalytics.js is not loaded!')
            //  }
            let obj = {
                cartId: localStorage.getItem("cartId"),
                sku: product.sku,
                quantity: box,
                custom_price: sellingPrice,
                pincode: pincode
            };
            if (localStorage.getItem("userToken")) {
                obj = {
                    ...obj,
                    token
                };
            }
            try {
                var ref, ref1;
                if (type == "sample") {
                    var ref2, ref3, ref4, ref5;
                    if (!token) {
                        router.push("/account?redirect=".concat(props === null || props === void 0 ? void 0 : props.urlKey));
                        return;
                    }
                    let cartDetailOfUser = await (0,cart/* getCartDataFromServer */.XM)(obj);
                    if (cartDetailOfUser.data.cart.pincode && cartDetailOfUser.data.cart.pincode != pincode && ((ref2 = cartDetailOfUser.data.cart.items) === null || ref2 === void 0 ? void 0 : ref2.length) > 0) {
                        sweetalert_min_default()("You already have some items in your cart for ".concat(cartDetailOfUser.data.cart.pincode, ", please remove items to continue with ").concat(pincode));
                        return;
                    }
                    if (((ref3 = cartDetailOfUser.data.cart.items) === null || ref3 === void 0 ? void 0 : ref3.length) > 0 && cartDetailOfUser.data.cart.items.filter((cur)=>cur.prices.price.value == 0).length > 4) {
                        sweetalert_min_default()("you can't add more than 5 sample products in an order");
                        return;
                    }
                    if (((ref4 = cartDetailOfUser.data.cart.items) === null || ref4 === void 0 ? void 0 : ref4.length) > 0 && cartDetailOfUser.data.cart.items.filter((cur)=>cur.product.sku == product.sku && cur.prices.price.value == 0).length) {
                        sweetalert_min_default()("You can't order more than 1 quantity for sample");
                        return;
                    }
                    if (((ref5 = cartDetailOfUser.data.cart.items) === null || ref5 === void 0 ? void 0 : ref5.length) > 0 && cartDetailOfUser.data.cart.items.filter((cur)=>cur.product.sku == product.sku && cur.prices.price.value != 0).length) {
                        sweetalert_min_default()("This product is already added in your cart as non-sample, please  remove it to order a sample");
                        return;
                    }
                    // if(cartDetailOfUser.data.cart.items.filter((cur)=>cur.prices.price.value > 0).length){
                    //    swal("You Can't add Sample product with")
                    //    return
                    // }
                    const addItem = await (0,cart/* addToCartWithPrice */.GN)({
                        ...obj,
                        quantity: 1,
                        custom_price: 0
                    });
                    if (addItem === null || addItem === void 0 ? void 0 : addItem.message) {
                        sweetalert_min_default()(addItem.message);
                    } else {
                        localStorage.setItem("CartData", JSON.stringify(addItem.data.addSimpleProductsToCartCustomPrice));
                        sweetalert_min_default()("".concat(product.name, " added in your cart as sample"));
                        const storageChangeEvent = new CustomEvent("localCartChanged", {
                            detail: {
                                key: "CartData",
                                newValue: ""
                            }
                        });
                        window.dispatchEvent(storageChangeEvent);
                    }
                    return;
                }
                if (!transportValue) {
                    setGetInTouch(true);
                    setThrowConfetti(false);
                    return;
                }
                let cartDetailOfUser1 = await (0,cart/* getCartDataFromServer */.XM)(obj);
                if (cartDetailOfUser1.data.cart.pincode && cartDetailOfUser1.data.cart.pincode != pincode && ((ref = cartDetailOfUser1.data.cart.items) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                    sweetalert_min_default()("You already have some items in your cart for ".concat(cartDetailOfUser1.data.cart.pincode, ", please remove items to continue with ").concat(pincode));
                    return;
                }
                if (((ref1 = cartDetailOfUser1.data.cart.items) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && cartDetailOfUser1.data.cart.items.filter((cur)=>cur.product.sku == product.sku && cur.prices.price.value == 0).length) {
                    sweetalert_min_default()("Sample of this product is already in your cart, please remove it to continue buying it as a non-sample");
                    return;
                }
                //   const addedItem = await addToCart(obj);
                const addedItem = await (0,cart/* addToCartWithPrice */.GN)(obj);
                if (addedItem === null || addedItem === void 0 ? void 0 : addedItem.message) {
                    sweetalert_min_default()(addedItem.message);
                } else {
                    localStorage.setItem("CartData", JSON.stringify(addedItem.data.addSimpleProductsToCartCustomPrice));
                    //  console.log(addedItem.data.addSimpleProductsToCart.cart,"uuuuuuuuuuuuuu")
                    sweetalert_min_default()("".concat(product.name, " Added in your Cart"));
                    if (type == "buy") {
                        router.push("/checkout");
                    }
                    const storageChangeEvent1 = new CustomEvent("localCartChanged", {
                        detail: {
                            key: "CartData",
                            newValue: ""
                        }
                    });
                    //  window.dispatchEvent(new Event('storage'));
                    window.dispatchEvent(storageChangeEvent1);
                }
            } catch (error) {
                console.log("Error occurred while adding to cart:", error);
            }
        } else {
            let emptyCart = await (0,cart/* createGuestEmptyCart */.DU)();
            localStorage.setItem("cartId", emptyCart.data.createEmptyCart);
            addProductToCart(type);
        }
    };
    // const downloadZip = (images) => {
    //    const zip = new JSZip();
    //    const promises = images.map((url, index) => {
    //       var myHeaders = new Headers();
    //       myHeaders.append("apiType", url.url);
    //       var requestOptions = {
    //          method: 'GET',
    //          headers: myHeaders,
    //        };
    //      return fetch(config.PROXY_SERVER_ENDPOINT,requestOptions)
    //        .then((response) => response.blob())
    //        .then((blob) => {
    //          zip.file(`image${index + 1}.jpg`, blob);
    //        });
    //    });
    //    Promise.all(promises)
    //      .then(() => zip.generateAsync({ type: 'blob' }))
    //      .then((content) => {
    //        const link = document.createElement('a');
    //        link.href = URL.createObjectURL(content);
    //        link.download = 'images.zip';
    //        link.click();
    //        URL.revokeObjectURL(link.href);
    //      });
    //  };
    const downloadZip = (images)=>{
        if (!localStorage.getItem("userToken")) {
            router.push("/account?redirect=".concat(props === null || props === void 0 ? void 0 : props.urlKey));
            return;
        }
        const imageUrls = images.map((cur)=>{
            return cur === null || cur === void 0 ? void 0 : cur.url;
        });
        fetch("".concat(config/* default.PROXY_SERVER_ENDPOINT */.Z.PROXY_SERVER_ENDPOINT, "download/zip"), {
            //  fetch(`http://localhost:3001/api/zip`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                imageUrls
            })
        }).then((response)=>response.json()).then((data)=>{
            // Access the generated ZIP file URL
            const zipUrl = data.zipUrl;
            // Use the ZIP file URL as needed
            const newWindow = window.open(zipUrl, "_blank");
            newWindow.opener = null;
        }).catch((error)=>{
            console.log("Failed to generate ZIP file:", error);
        });
    };
    const productsliderthumb = {
        dots: false,
        infinite: false,
        slidesToShow: 6,
        slidesToScroll: 1,
        vertical: true,
        verticalSwiping: true,
        swipeToSlide: true,
        beforeChange: function(currentSlide, nextSlide) {
        //   console.log("before change", currentSlide, nextSlide);
        },
        afterChange: function(currentSlide) {
        //   console.log("after change", currentSlide);
        }
    };
    const submitGetInTouch = async (subsource)=>{
        const namee = touch.name;
        const no = touch.number;
        if (!namee || !no) {
            setTouch({
                ...touch,
                error: "Both fields are required"
            });
        } else if (String(no).length > 13 || String(no).length < 9) {
            setTouch({
                ...touch,
                error: "Invalid Phone number"
            });
        } else {
            setTouch({
                ...touch,
                error: "",
                loading: true
            });
            try {
                let response = await (0,others/* getIntouch */.JJ)({
                    name: namee,
                    phone: no,
                    pincode: pincode,
                    call_id: subsource
                });
                if (response === null || response === void 0 ? void 0 : response.message) {
                    localStorage.setItem("leadfilled", true);
                    sweetalert_min_default()(response === null || response === void 0 ? void 0 : response.message);
                } else {
                    sweetalert_min_default()(response.data.get_in_touch.msg);
                    setGetInTouch(false);
                    setTouch({
                        name: "",
                        number: "",
                        pincode: "",
                        error: "",
                        loading: false,
                        email: ""
                    });
                }
            } catch (error) {
                console.log("Error submitting form:", error);
                setTouch({
                    ...touch,
                    error: "Error submitting form",
                    loading: false
                });
            }
        }
    };
    const settings3 = {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        centerMode: true,
        autoplaySpeed: 3000,
        arrows: false,
        dots: true,
        centerPadding: "0px"
    };
    const [show, setShow] = (0,react.useState)(false);
    const handleClose = ()=>setShow(false);
    const handleShow = ()=>setShow(true);
    const handleCloseModal = ()=>setIsModalOpen(false);
    const [bestPricesLoading, setBestPricesLoading] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        const loadYouTubeAPI = ()=>{
            if (typeof YT === "undefined" || typeof YT.Player === "undefined") {
                // Load the YouTube IFrame API script
                const tag = document.createElement("script");
                tag.src = "https://www.youtube.com/iframe_api";
                tag.async = true;
                document.body.appendChild(tag);
                // Define the global API ready function
                window.onYouTubeIframeAPIReady = initializePlayer;
            } else {
                initializePlayer();
            }
        };
        const initializePlayer = ()=>{
            if (videoURL) {
                const videoId = getYouTubeVideoID(videoURL); // Extract the video ID
                new YT.Player("youtube-player", {
                    videoId: videoId,
                    events: {
                        onStateChange: onPlayerStateChange
                    }
                });
            }
        };
        const onPlayerStateChange = (event)=>{
            if (event.data === YT.PlayerState.PLAYING) {
                // Log the play event to Google Analytics
                window.gtag("event", "Quicklook video play", {
                    event_category: "Video",
                    event_label: "YouTube Video"
                });
            }
        };
        const getYouTubeVideoID = (url)=>{
            const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
            const match = url.match(regex);
            return match ? match[1] : null;
        };
        // Load the YouTube API script
        loadYouTubeAPI();
    }, [
        videoURL
    ]);
    const getBestPrice = async (pin, factory)=>{
        setBestPricesLoading(true);
        if (!(pin === null || pin === void 0 ? void 0 : pin.length) == 6) {
            sweetalert_min_default()("please enter valid pincode to get best prices");
        } else {
            var ref;
            let apiresult = await axios/* default.get */.Z.get("https://obl-js.orientbell.com/api/product-availability-dev?sku=".concat(product.sku, "&pincode=").concat(pin, "&factory=").concat(factory));
            if ((ref = apiresult.data) === null || ref === void 0 ? void 0 : ref.devliverytime) {
                var ref1, ref2, ref3, ref4, ref5, ref6, ref7;
                if (((ref1 = apiresult.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Plants) === null || ref2 === void 0 ? void 0 : ref2.length) > 0) {
                    var ref8, ref9, ref10, ref11;
                    let temparr = [];
                    if ((ref8 = apiresult.data) === null || ref8 === void 0 ? void 0 : ref8.Plants.includes("Sikandrabad Plant")) {
                        temparr.push(Number(product.extraVariables.skd_stock));
                    }
                    if ((ref9 = apiresult.data) === null || ref9 === void 0 ? void 0 : ref9.Plants.includes("Dora Plant")) {
                        temparr.push(Number(product.extraVariables.dora_stock));
                    }
                    if ((ref10 = apiresult.data) === null || ref10 === void 0 ? void 0 : ref10.Plants.includes("Hoskote Plant")) {
                        temparr.push(Number(product.extraVariables.hoskote_stock));
                    }
                    if ((ref11 = apiresult.data) === null || ref11 === void 0 ? void 0 : ref11.Plants.includes("West Zone")) {
                        temparr.push(Number(product.extraVariables.west_zone_stock));
                    }
                    setAvailableStock(temparr.reduce((total, obj)=>total + obj, 0));
                }
                if (((ref3 = apiresult.data) === null || ref3 === void 0 ? void 0 : ref3.transportOrder) == 0) {
                    var ref12, ref13;
                    setThrowConfetti(false);
                    setDeliveryDate((ref12 = apiresult.data) === null || ref12 === void 0 ? void 0 : ref12.devliverytime);
                    setBestPricesLoading(false);
                    settransportValue((ref13 = apiresult.data) === null || ref13 === void 0 ? void 0 : ref13.transportOrder);
                    return;
                }
                setDeliveryDate((ref4 = apiresult.data) === null || ref4 === void 0 ? void 0 : ref4.devliverytime);
                setBestPricesLoading(false);
                settransportValue((ref5 = apiresult.data) === null || ref5 === void 0 ? void 0 : ref5.transportOrder);
                if (apiresult.data.updated_price == 0) {
                    setGetInTouch(true);
                    // setIsModalOpen("You have the best offer right now.")
                    setCheckAviabilty(true);
                // swal("You have the best offer right now.")
                } else if (((ref6 = apiresult.data) === null || ref6 === void 0 ? void 0 : ref6.updated_price_ft) && ((ref7 = apiresult.data) === null || ref7 === void 0 ? void 0 : ref7.updated_price_ft) * product.extraVariables.total_area_sq_ft < Math.round(Number(product.extraVariables.total_area_sq_ft) * (Number(product.extraVariables.sq_ft_price) - Number(product.extraVariables.discounted_price)))) {
                    var ref14, ref15, ref16, ref17;
                    setThrowConfetti(true);
                    // alert(Math.round(apiresult.data?.updated_price_ft * SqFtPerBox))
                    function percentageDiscount(a, b) {
                        let res = Math.round((a - b) / a * 100);
                        return res;
                    }
                    let perrr = percentageDiscount(Math.round(Number(product.extraVariables.total_area_sq_ft) * (Number(product.extraVariables.sq_ft_price) - Number(product.extraVariables.discounted_price))), ((ref14 = apiresult.data) === null || ref14 === void 0 ? void 0 : ref14.updated_price_ft) * product.extraVariables.total_area_sq_ft);
                    const seeelling = Math.round(Number(product.extraVariables.total_area_sq_ft) * (Number(product.extraVariables.sq_ft_price) - Number(product.extraVariables.discounted_price)));
                    setMrp(seeelling);
                    setSellingPrice(Math.round(((ref15 = apiresult.data) === null || ref15 === void 0 ? void 0 : ref15.updated_price_ft) * product.extraVariables.total_area_sq_ft));
                    setTotalMrpPrice(seeelling * box);
                    setTotalSellingPrice(((ref16 = apiresult.data) === null || ref16 === void 0 ? void 0 : ref16.updated_price_ft) * product.extraVariables.total_area_sq_ft * box);
                    setupdated_price_ft((ref17 = apiresult.data) === null || ref17 === void 0 ? void 0 : ref17.updated_price_ft);
                    setIsModalOpen("Hey, you just saved ".concat(perrr, "% on price. Hurry! Offer price for limited period."));
                    setBestPricesLoading(false);
                    setCheckAviabilty(true);
                    setTimeout(()=>{
                        setThrowConfetti(false);
                    }, 3000);
                }
            } else if (1 > apiresult.data.availableQty) {
                setThrowConfetti(false);
                setIsModalOpen("This Product is out of stock at ".concat(pin));
                setBestPricesLoading(false);
                setPincode("");
                setCheckAviabilty(false);
            } else if (apiresult.data.addesses == "" || !apiresult.data.devliverytime) {
                // setDeliveryDate(apiresult.data?.devliverytime)
                setThrowConfetti(false);
                setIsModalOpen("This Product is not Deliverable at ".concat(pin));
                //trackProductUnavailability(product.sku, pin)
                setBestPricesLoading(false);
                setPincode("");
                setCheckAviabilty(false);
            }
        }
    };
    const breadsCrumbSchema = ()=>{
        return {
            __html: '{\n      "@context": "https://schema.org/", \n      "@type": "BreadcrumbList", \n      "itemListElement": [{\n        "@type": "ListItem", \n        "position": 1, \n        "name": "Home",\n        "item": "https://staging.orientbell.com"\n      },{\n        "@type": "ListItem", \n        "position": 2, \n        "name": "Tiles",\n        "item": "https://staging.orientbell.com/tiles"  \n      },{\n       "@type": "ListItem", \n       "position": 3, \n       "name": "'.concat(product === null || product === void 0 ? void 0 : product.name, '",\n       "item": "').concat(router.asPath, '"  \n     }]}')
        };
    };
    const webPageSchema = ()=>{
        return {
            __html: '{\n      "@context": "https://schema.org",\n      "@type": "WebPage",\n      "url": "'.concat(router.asPath, '",\n      "headline": "",\n      "name": "').concat(product === null || product === void 0 ? void 0 : product.name, '",\n      "description": "Shop online ').concat(product === null || product === void 0 ? void 0 : product.name, '  Tiles at best price from Orientbell Tiles. Applicable for multiple spaces. Buy online or from nearest tiles store!"\n    }')
        };
    };
    let productSchema = ()=>null;
    if (((ref5 = props.getProductSetail) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.data) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.products) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.items) === null || ref8 === void 0 ? void 0 : ref8.length) > 0) {
        productSchema = ()=>{
            var ref, ref1, ref2, ref3, ref4;
            const schema = {
                "@context": "https://schema.org",
                "@type": "Product",
                brand: "Orientbell",
                URL: "".concat(config/* default.HEADLESS_BASE_URL */.Z.HEADLESS_BASE_URL, "/").concat(props.productSlug),
                category: "".concat(props.getProductSetail.data.products.items[0].extraVariables.suitable_for.map((cur, index)=>{
                    return cur.label;
                })),
                description: "Shop online ".concat((ref = props.getProductSetail.data.products.items[0]) === null || ref === void 0 ? void 0 : ref.name, " Floor  Tiles at the best price from Orientbell Tiles. Applicable for multiple spaces. Buy online or from the nearest tiles store!"),
                name: "".concat((ref1 = props.getProductSetail.data.products.items[0]) === null || ref1 === void 0 ? void 0 : ref1.name),
                manufacturer: "Orient Bell Limited",
                material: "".concat(props.getProductSetail.data.products.items[0].extraVariables.material.map((cur, index)=>{
                    return cur.label;
                })),
                image: "".concat((ref2 = props.getProductSetail.data.products.items[0].image) === null || ref2 === void 0 ? void 0 : ref2.url),
                offers: {
                    "@type": "Offer",
                    url: "".concat(config/* default.HEADLESS_BASE_URL */.Z.HEADLESS_BASE_URL, "/").concat(props.productSlug),
                    priceCurrency: "INR",
                    price: "".concat(props.getProductSetail.data.products.items[0].extraVariables.sq_ft_price),
                    itemOffered: "/sqft"
                },
                aggregateRating: {
                    "@type": "AggregateRating",
                    ratingValue: "5.00",
                    ratingCount: "".concat(((ref3 = props.getProductSetail.data.products.items[0].extraVariables.rating_summary) === null || ref3 === void 0 ? void 0 : ref3.avg_rating) ? (ref4 = props.getProductSetail.data.products.items[0].extraVariables.rating_summary) === null || ref4 === void 0 ? void 0 : ref4.avg_rating.toFixed(2) : 5)
                },
                review: (reviews === null || reviews === void 0 ? void 0 : reviews.length) > 0 ? reviews.map((rev)=>{
                    return {
                        "@type": "Review",
                        reviewRating: {
                            "@type": "Rating",
                            ratingValue: "".concat(rev.rating),
                            bestRating: "5"
                        },
                        reviewBody: "".concat(rev.detail),
                        author: {
                            "@type": "Person",
                            name: "".concat(rev.customer_name)
                        }
                    };
                }) : ""
            };
            // Convert the JavaScript object to a JSON string
            const jsonString = {
                __html: JSON.stringify(schema).replace(/&quot;/g, '"')
            };
            // Return the JSON string
            return jsonString;
        };
    }
    const imageObjectSchema = ()=>{
        var ref, ref1, ref2;
        const images = ((ref = props.getProductSetail) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.products) === null || ref2 === void 0 ? void 0 : ref2.items[0].extraVariables.images) || [];
        // const altText = `${props.getProductSetail.data.products.items[0].extraVariables.finish[0].label} ${props.getProductSetail.data.products.items[0].name} ${props.getProductSetail.data.products.items[0].extraVariables.material[0].label} ${props.getProductSetail.data.products.items[0].extraVariables.type[0].label || props.getProductSetail.data.products.items[0].extraVariables.tile_size}`;
        // Build the schema with @context and @graph for multiple ImageObjects
        const schema = {
            "@context": "https://schema.org",
            "@graph": images.map((image)=>({
                    "@type": "ImageObject",
                    contentUrl: image.url,
                    description: generateAltText(),
                    caption: generateAltText(),
                    width: "600",
                    height: "900"
                }))
        };
        // Return JSON-LD formatted HTML-safe string
        return {
            __html: JSON.stringify(schema)
        };
    };
    //  console.log("PRODUCT ------", product)
    const [callBackDto, setCallBackDto] = (0,react.useState)({
        name: "",
        number: "",
        pincode: js_cookie/* default.get */.Z.get("pincode"),
        error: "",
        loading: false,
        countryCode: "",
        email: "",
        cc: ""
    });
    const onSubmitClick = async ()=>{
        const namee = callBackDto.name;
        const no = callBackDto.number;
        if (!namee || !no) {
            setCallBackDto({
                ...callBackDto,
                error: "Both Field Are Required"
            });
        } else {
            setCallBackDto({
                ...callBackDto,
                error: "",
                loading: true
            });
            //gtagConversionEvent()
            let response = await (0,others/* requestCallback */.mq)({
                name: namee,
                phone: no,
                pincode: callBackDto.pincode ? callBackDto.pincode : ""
            });
            if (response === null || response === void 0 ? void 0 : response.message) {
                localStorage.setItem("leadfilled", true);
                sweetalert_min_default()(response === null || response === void 0 ? void 0 : response.message);
                setCallBackDto({
                    ...callBackDto,
                    error: "",
                    loading: false
                });
            } else {
                sweetalert_min_default()(response.data.request_callback.msg);
                setCallBackDto({
                    name: "",
                    number: "",
                    error: "",
                    loading: false
                });
            }
        }
    };
    const onValueChange = (e, title)=>{
        setCallBackDto({
            ...callBackDto,
            [title]: e.target.value
        });
    };
    const generateAltText = ()=>{
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32;
        const finish = ((ref5 = (ref3 = props === null || props === void 0 ? void 0 : (ref = props.getProductSetail) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.products) === null || ref2 === void 0 ? void 0 : ref2.items[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.extraVariables) === null || ref4 === void 0 ? void 0 : ref4.finish[0]) === null || ref5 === void 0 ? void 0 : ref5.label) || "";
        const material = ((ref11 = (ref9 = props === null || props === void 0 ? void 0 : (ref6 = props.getProductSetail) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.data) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.products) === null || ref8 === void 0 ? void 0 : ref8.items[0]) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.extraVariables) === null || ref10 === void 0 ? void 0 : ref10.material[0]) === null || ref11 === void 0 ? void 0 : ref11.label) || "";
        const type = ((ref17 = (ref15 = props === null || props === void 0 ? void 0 : (ref12 = props.getProductSetail) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.data) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.products) === null || ref14 === void 0 ? void 0 : ref14.items[0]) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.extraVariables) === null || ref16 === void 0 ? void 0 : ref16.type[0]) === null || ref17 === void 0 ? void 0 : ref17.label) != "false" ? (ref23 = (ref21 = props === null || props === void 0 ? void 0 : (ref18 = props.getProductSetail) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.data) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.products) === null || ref20 === void 0 ? void 0 : ref20.items[0]) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.extraVariables) === null || ref22 === void 0 ? void 0 : ref22.type[0]) === null || ref23 === void 0 ? void 0 : ref23.label : "";
        const size = ((ref27 = props === null || props === void 0 ? void 0 : (ref24 = props.getProductSetail) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.data) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.products) === null || ref26 === void 0 ? void 0 : ref26.items[0]) === null || ref27 === void 0 ? void 0 : (ref28 = ref27.extraVariables) === null || ref28 === void 0 ? void 0 : ref28.tile_size) || "";
        const productName = ((ref32 = props === null || props === void 0 ? void 0 : (ref29 = props.getProductSetail) === null || ref29 === void 0 ? void 0 : (ref30 = ref29.data) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.products) === null || ref31 === void 0 ? void 0 : ref31.items[0]) === null || ref32 === void 0 ? void 0 : ref32.name) || "";
        if (type && material.toLowerCase().includes("tile")) {
            return "".concat(finish, " ").concat(productName, " ").concat(material, " ").concat(type);
        } else {
            const materialWithTile = material.toLowerCase().includes("tile") ? material : "".concat(material, " tile");
            return "".concat(finish, " ").concat(productName, " ").concat(materialWithTile, " ").concat(size);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        charset: "utf-8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "title",
                        content: "Buy ".concat(product === null || product === void 0 ? void 0 : product.name, " ").concat((product === null || product === void 0 ? void 0 : (ref9 = product.extraVariables) === null || ref9 === void 0 ? void 0 : ref9.type[0].label) !== "false" ? product.extraVariables.type[0].label : "Floor and Wall Tiles", " Online | Orientbell Tiles")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Buy ".concat(product === null || product === void 0 ? void 0 : product.name, "  ").concat((product === null || product === void 0 ? void 0 : (ref10 = product.extraVariables) === null || ref10 === void 0 ? void 0 : ref10.type[0].label) !== "false" ? product.extraVariables.type[0].label : "Floor and Wall Tiles", " Online | Orientbell Tiles")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Shop online ".concat(product === null || product === void 0 ? void 0 : product.name, "  Tiles at the right price from Orientbell Tiles. Applicable for multiple spaces. Buy online or from nearest tiles store!")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: "".concat(product === null || product === void 0 ? void 0 : product.name, ", ").concat(product === null || product === void 0 ? void 0 : product.name, " tiles, Orientbell ").concat(product === null || product === void 0 ? void 0 : product.name, " tiles, ").concat(product === null || product === void 0 ? void 0 : product.name, " tiles price, ").concat(product === null || product === void 0 ? void 0 : product.name, " tiles specification, ").concat(product === null || product === void 0 ? void 0 : product.name, " tiles ").concat(product === null || product === void 0 ? void 0 : (ref11 = product.extraVariables) === null || ref11 === void 0 ? void 0 : ref11.size, " mm")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "format-detection",
                        content: "telephone=no"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "pinterest-rich-pin",
                        content: "false"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: "Shop online ".concat(product === null || product === void 0 ? void 0 : product.name, "  Tiles at the right price from Orientbell Tiles. Applicable for multiple spaces. Buy online or from nearest tiles store!")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: product === null || product === void 0 ? void 0 : (ref12 = product.extraVariables) === null || ref12 === void 0 ? void 0 : ref12.image_url
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:url",
                        content: product === null || product === void 0 ? void 0 : (ref13 = product.image) === null || ref13 === void 0 ? void 0 : ref13.url
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:site",
                        content: "Orientbell"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:creator",
                        content: "Orientbell"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "Buy ".concat(product === null || product === void 0 ? void 0 : product.name, " Floor  Tiles Online | Orientbell Tiles")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: "Shop online ".concat(product === null || product === void 0 ? void 0 : product.name, "  Tiles at the right price from Orientbell Tiles. Applicable for multiple spaces. Buy online or from nearest tiles store!")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: product === null || product === void 0 ? void 0 : (ref14 = product.extraVariables) === null || ref14 === void 0 ? void 0 : ref14.image_url
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: product === null || product === void 0 ? void 0 : (ref15 = product.image) === null || ref15 === void 0 ? void 0 : ref15.url
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "og:product"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "text/javascript",
                        src: "https://cdn.roomvo.com/static/scripts/b2b/orientbell.js",
                        defer: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: productSchema()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: imageObjectSchema()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: webPageSchema()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: breadsCrumbSchema()
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                show: show,
                onHide: handleClose,
                className: "exclamation_size_modal",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                        closeButton: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "../tiles-size-guide.jpg",
                            style: {
                                width: "100%"
                            },
                            alt: "image"
                        })
                    })
                ]
            }),
            isModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                className: "product_defaultModal",
                size: "lg",
                show: isModalOpen,
                onHide: handleCloseModal,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                        closeButton: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Title */.Z.Title, {
                            children: isModalOpen
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "primary",
                        onClick: handleCloseModal,
                        children: "Close"
                    })
                ]
            }),
            Loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(loader/* default */.Z, {})
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "productdetail",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container_new",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "breadcumb",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                            href: "/",
                                            children: "Home"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                            href: "/tiles",
                                            children: "Tiles"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                            active: true,
                                            children: product === null || product === void 0 ? void 0 : product.name
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* RWebShare */.u, {
                                        data: {
                                            text: product.name,
                                            url: "".concat(config/* default.HEADLESS_BASE_URL */.Z.HEADLESS_BASE_URL, "/").concat(props === null || props === void 0 ? void 0 : props.urlKey),
                                            title: product.name
                                        },
                                        sites: [
                                            "whatsapp",
                                            "facebook",
                                            "linkedin",
                                            "copy"
                                        ],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                "Share on ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaShareAlt */.PPi, {})
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "productslider-row-asas",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "productslider",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "product-left",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "product_desktop_view_slider",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "thumbnail-bx",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                                                            ...productsliderthumb,
                                                            children: (ref16 = product.media_gallery) === null || ref16 === void 0 ? void 0 : ref16.map((e, i)=>{
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    onClick: ()=>{
                                                                        setProductImg(e === null || e === void 0 ? void 0 : e.url);
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        src: e === null || e === void 0 ? void 0 : e.url,
                                                                        title: generateAltText(),
                                                                        alt: generateAltText()
                                                                    })
                                                                }, i);
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "product-img-view",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: productImg,
                                                                style: {
                                                                    width: "100%"
                                                                },
                                                                title: generateAltText(),
                                                                alt: generateAltText()
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "roomvo-container",
                                                                "data-product-type-str": "",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                    className: "roomvo-stimr listing-button my-room-btn",
                                                                    "data-sku": product.sku,
                                                                    style: {
                                                                        visibility: "hidden"
                                                                    },
                                                                    children: "Try in my room"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "product_mobile_view_slider",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                                                        ...settings3,
                                                        children: product.media_gallery.map((e, i)=>{
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "product-img-view",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        src: e === null || e === void 0 ? void 0 : e.url,
                                                                        title: generateAltText(),
                                                                        alt: generateAltText()
                                                                    })
                                                                })
                                                            }, i);
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "roomvo-container",
                                                        "data-product-type-str": "",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            className: "roomvo-stimr listing-button my-room-btn",
                                                            "data-sku": product.sku,
                                                            style: {
                                                                visibility: "hidden"
                                                            },
                                                            children: "Try in my room"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "productpara",
                                    children: [
                                        viewCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "view-count",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/upword-arrow.svg"
                                                    }),
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        class: "fa-solid fa-arrow-trend-up"
                                                    }),
                                                    "Recent views: \xa0",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                        children: [
                                                            " ",
                                                            viewCount
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            className: "mt-0",
                                            children: product.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "prorating",
                                            children: [
                                                ((ref17 = product.extraVariables.rating_summary) === null || ref17 === void 0 ? void 0 : ref17.avg_rating) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            class: "product-rating-row",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stars/* default */.Z, {
                                                                    count: 5,
                                                                    value: (ref18 = product.extraVariables.rating_summary) === null || ref18 === void 0 ? void 0 : ref18.avg_rating,
                                                                    edit: false,
                                                                    color2: "#ff5e00"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    style: {
                                                                        paddingLeft: "5px",
                                                                        fontSize: "13px"
                                                                    },
                                                                    itemscope: "",
                                                                    itemtype: "http://schema.org/AggregateRating",
                                                                    children: [
                                                                        (ref19 = product.extraVariables.rating_summary) === null || ref19 === void 0 ? void 0 : ref19.avg_rating.toFixed(2),
                                                                        " ",
                                                                        "Rating"
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            "data-toggle": "tooltip",
                                                            "data-placement": "bottom",
                                                            title: product.extraVariables.rating_summary.avg_percentage
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                    children: checkAviabilty ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                style: {
                                                                    display: "inline-block",
                                                                    width: "10px",
                                                                    height: "10px",
                                                                    borderRadius: "50%",
                                                                    backgroundColor: AvailableStock > 0 && AvailableStock <= 100 ? "red" : AvailableStock > 100 && AvailableStock <= 250 ? "orange" : AvailableStock > 250 && AvailableStock <= 1000 ? "lightgreen" : AvailableStock > 1000 ? "darkgreen" : "grey",
                                                                    marginRight: "5px"
                                                                }
                                                            }),
                                                            AvailableStock > 0 && AvailableStock <= 100 ? "Out of Stock" : AvailableStock > 100 && AvailableStock <= 250 ? "Low Stock" : AvailableStock > 250 && AvailableStock <= 1000 ? "Limited Stock" : AvailableStock > 1000 ? "In Stock" : "Out of Stock",
                                                            " "
                                                        ]
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "new_avialabily",
                                                        children: "Not Deliverable"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "prolocation",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default */.Z, {
                                                onSubmit: (e)=>e.preventDefault(),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputGroup/* default */.Z, {
                                                        className: "p-2",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputGroup/* default.Text */.Z.Text, {
                                                                id: "basic-addon1",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaLocationArrow */.nkz, {})
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                                placeholder: "Enter pincode",
                                                                "aria-label": "Username",
                                                                "aria-describedby": "basic-addon1",
                                                                type: "number",
                                                                value: pincode,
                                                                onChange: (e)=>{
                                                                    if (String(e.target.value).length <= 6) {
                                                                        if (String(e.target.value).length == 6) {
                                                                            // if(!localStorage.getItem('pincode')){
                                                                            //     setThrowConfetti(true)
                                                                            // }
                                                                            getBestPrice(e.target.value, product.extraVariables.factory);
                                                                            setBestPricesLoading();
                                                                            setPincode(e.target.value);
                                                                            js_cookie/* default.set */.Z.set("pincode", e.target.value, {
                                                                                expires: 7
                                                                            });
                                                                        } else {
                                                                            setPincode(e.target.value);
                                                                        }
                                                                    }
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    bestPricesLoading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                                                animation: "border",
                                                                variant: "success",
                                                                size: "sm"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "Loading..."
                                                            })
                                                        ]
                                                    }),
                                                    deliveryDate ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "deliv_date",
                                                        children: [
                                                            "Expected Delivery by ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                children: deliveryDate
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-danger",
                                                        children: "Please enter your pincode for best prices"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "p-2",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "pro_forminline",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                                                                htmlFor: "inputPassword5",
                                                                                children: "Total Area (Sq.ft.)"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                                                type: "Number",
                                                                                id: "inputPassword5",
                                                                                value: SqFt,
                                                                                "aria-describedby": "passwordHelpBlock",
                                                                                onChange: handleSqFtChange
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "procounter",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                                                                htmlFor: "inputPassword5",
                                                                                children: "Boxes"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: "pro_counterdata",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                        onClick: handleMinusBox,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaMinus */.iFH, {})
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                        children: box
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                        onClick: handlePlusBox,
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaPlus */.wEH, {})
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            mrp > sellingPrice ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                className: "pr_loc_total",
                                                                children: [
                                                                    "Estimated Price",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        children: [
                                                                            "Rs. ",
                                                                            Math.round(totalMrpPrice),
                                                                            " "
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("storng", {
                                                                        children: [
                                                                            "Rs.",
                                                                            Math.round(totalSellingPrice)
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "disclaimer-price-txt",
                                                                        children: "(Final Price Adjusted before Delivery)"
                                                                    })
                                                                ]
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                className: "pr_loc_total",
                                                                children: [
                                                                    "Estimated Price",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("storng", {
                                                                        children: [
                                                                            "Rs. ",
                                                                            Math.round(totalSellingPrice)
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                onClick: ()=>addProductToCart("add"),
                                                                variant: "outline-success",
                                                                //   unbxdattr="AddToCart"
                                                                unbxdparam_sku: product === null || product === void 0 ? void 0 : product.sku,
                                                                unbxdparam_variant: "null",
                                                                unbxdparam_qty: "1",
                                                                children: "ADD TO CART"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                                                onClick: ()=>addProductToCart("buy"),
                                                                variant: "primary",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaTag */.fxx, {
                                                                        className: "faTagIcon"
                                                                    }),
                                                                    "BUY NOW"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "prodeatilcard",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                                                defaultActiveKey: "0",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default.Item */.Z.Item, {
                                                    eventKey: "0",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default.Header */.Z.Header, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                children: "Details"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default.Body */.Z.Body, {
                                                            children: [
                                                                Array.isArray(product.extraVariables.material) && ((ref20 = product.extraVariables.material) === null || ref20 === void 0 ? void 0 : ref20.filter((cur)=>{
                                                                    return (cur === null || cur === void 0 ? void 0 : cur.label) != "false";
                                                                }).length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: "Material"
                                                                        }),
                                                                        product.extraVariables.material.map((e, i)=>{
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                                                                href: "".concat(config/* default.HEADLESS_BASE_URL */.Z.HEADLESS_BASE_URL, "/").concat(e.url_key),
                                                                                children: [
                                                                                    " ",
                                                                                    e.label,
                                                                                    " ",
                                                                                    i + 1 != product.extraVariables.material.length && ","
                                                                                ]
                                                                            }, i);
                                                                        })
                                                                    ]
                                                                }),
                                                                Array.isArray(product.extraVariables.finish) && ((ref21 = product.extraVariables.finish) === null || ref21 === void 0 ? void 0 : ref21.filter((cur)=>{
                                                                    return (cur === null || cur === void 0 ? void 0 : cur.label) != "false";
                                                                }).length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: "Finish"
                                                                        }),
                                                                        product.extraVariables.finish.map((e, i)=>{
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                                                                href: "".concat(config/* default.HEADLESS_BASE_URL */.Z.HEADLESS_BASE_URL, "/").concat(e.url_key),
                                                                                children: [
                                                                                    " ",
                                                                                    e.label,
                                                                                    " ",
                                                                                    i + 1 != product.extraVariables.finish.length && ","
                                                                                ]
                                                                            }, i);
                                                                        })
                                                                    ]
                                                                }),
                                                                Array.isArray(product.extraVariables.type) && ((ref22 = product.extraVariables.type) === null || ref22 === void 0 ? void 0 : ref22.filter((cur)=>{
                                                                    return (cur === null || cur === void 0 ? void 0 : cur.label) != "false";
                                                                }).length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: "Type"
                                                                        }),
                                                                        product.extraVariables.type.map((e, i)=>{
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                                                                href: "".concat(config/* default.HEADLESS_BASE_URL */.Z.HEADLESS_BASE_URL, "/").concat(e.url_key),
                                                                                children: [
                                                                                    " ",
                                                                                    e.label,
                                                                                    " ",
                                                                                    i + 1 != product.extraVariables.type.length && ","
                                                                                ]
                                                                            }, i);
                                                                        })
                                                                    ]
                                                                }),
                                                                ((ref23 = product.extraVariables.size_option.filter((cur)=>cur.label != "false")) === null || ref23 === void 0 ? void 0 : ref23.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                            children: [
                                                                                "Size",
                                                                                " ",
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: "exclamation_icon",
                                                                                    onClick: handleShow,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                        height: "20px",
                                                                                        src: "/infoicon.png"
                                                                                    })
                                                                                })
                                                                            ]
                                                                        }),
                                                                        product.extraVariables.size_option.map((e, i)=>{
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                                                                href: "".concat(config/* default.HEADLESS_BASE_URL */.Z.HEADLESS_BASE_URL, "/").concat(e.url_key),
                                                                                children: [
                                                                                    " ",
                                                                                    e.label,
                                                                                    " ",
                                                                                    i + 1 != product.extraVariables.size_option.length && ","
                                                                                ]
                                                                            }, i);
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: "Price"
                                                                        }),
                                                                        selectedSeze == "FT" ? updated_price_ft ? "Offer Price Rs ".concat(parseFloat(updated_price_ft).toFixed(2)) : "MRP Rs ".concat(parseFloat(product.extraVariables.sq_ft_price).toFixed(2)) : updated_price_ft ? "Offer Price Rs ".concat(updated_price_ft / (0.3048 * 0.3048).toFixed(2)) : "MRP Rs ".concat((product.extraVariables.sq_ft_price / (0.3048 * 0.3048)).toFixed(2)),
                                                                        "/sq.ft (incl. of all taxes)"
                                                                    ]
                                                                }),
                                                                Array.isArray(product.extraVariables.design) && ((ref24 = product.extraVariables.design) === null || ref24 === void 0 ? void 0 : ref24.filter((cur)=>{
                                                                    return (cur === null || cur === void 0 ? void 0 : cur.label) != "false";
                                                                }).length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: "Design"
                                                                        }),
                                                                        product.extraVariables.design.map((e, i)=>{
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                                                                href: "".concat(config/* default.HEADLESS_BASE_URL */.Z.HEADLESS_BASE_URL, "/").concat(e.url_key),
                                                                                children: [
                                                                                    " ",
                                                                                    e.label,
                                                                                    " ",
                                                                                    i + 1 != product.extraVariables.design.length && ","
                                                                                ]
                                                                            }, i);
                                                                        })
                                                                    ]
                                                                }),
                                                                Array.isArray(product.extraVariables.suitable_for) && ((ref25 = product.extraVariables.suitable_for) === null || ref25 === void 0 ? void 0 : ref25.filter((cur)=>{
                                                                    return (cur === null || cur === void 0 ? void 0 : cur.label) != "false";
                                                                }).length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: "Suitable for"
                                                                        }),
                                                                        product.extraVariables.suitable_for.map((e, i)=>{
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                                                                href: "".concat(config/* default.HEADLESS_BASE_URL */.Z.HEADLESS_BASE_URL, "/").concat(e.url_key),
                                                                                children: [
                                                                                    " ",
                                                                                    e.label,
                                                                                    " ",
                                                                                    i + 1 != product.extraVariables.suitable_for.length && ","
                                                                                ]
                                                                            }, i);
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        videoURL && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "quicklook-video-mobile",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                                id: "youtube-player",
                                                src: videoURL,
                                                frameborder: "0",
                                                height: "300px",
                                                width: "100%",
                                                allowfullscreen: "true"
                                            })
                                        }),
                                        (product === null || product === void 0 ? void 0 : (ref26 = product.description) === null || ref26 === void 0 ? void 0 : ref26.html) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "pro_about mob",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                dangerouslySetInnerHTML: {
                                                    __html: product.description.html
                                                }
                                            })
                                        }),
                                        ((ref27 = product.product_links) === null || ref27 === void 0 ? void 0 : ref27.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                    className: "looksgoodwith_head",
                                                    children: "Looks good with"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "prolooksgoodcard",
                                                    children: product.product_links.map((e, i)=>{
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "prolookdata",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                href: "".concat(config/* default.HEADLESS_BASE_URL */.Z.HEADLESS_BASE_URL, "/").concat(e === null || e === void 0 ? void 0 : e.url_key),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        src: e.image,
                                                                        alt: "image"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                        children: e.name
                                                                    })
                                                                ]
                                                            })
                                                        }, i);
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "protoolscard",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                                                defaultActiveKey: "0",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default.Item */.Z.Item, {
                                                    eventKey: "0",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default.Header */.Z.Header, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                children: "Pro Tools"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default.Body */.Z.Body, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "protoolsdata",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "toolscontent",
                                                                        onClick: ()=>downloadZip(product.media_gallery),
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaDownload */.aBF, {
                                                                                className: "proToolIcon"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                children: "Hi-Res Image"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "toolscontent",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                            href: "/pincode-based-quotation?pid=".concat(router.query.product),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaFileAlt */.mGS, {
                                                                                    className: "proToolIcon"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                    children: "Request Quote"
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "toolscontent",
                                                                        onClick: ()=>router.push("/construction-cost-calculator"),
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaCalculator */.T_s, {
                                                                                className: "proToolIcon"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                children: "Cost Estimator"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "toolscontent",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                            href: "/carpetlook?img=".concat((ref28 = product.media_gallery[0]) === null || ref28 === void 0 ? void 0 : ref28.url),
                                                                            target: "_blank",
                                                                            rel: "noopener noreferrer",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaSlackHash */.bdS, {
                                                                                    className: "proToolIcon"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                    children: "Laying Pattern"
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "toolscontent",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                            href: product.extraVariables.specifications,
                                                                            target: "_blank",
                                                                            rel: "noopener noreferrer",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaFilePdf */.yRW, {
                                                                                    className: "proToolIcon"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                    children: "Specifications"
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "toolscontent",
                                                                        onClick: ()=>router.push("/store-locator?sku=".concat(product.sku)),
                                                                        children: [
                                                                            " ",
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaStoreAlt */.LAK, {
                                                                                className: "proToolIcon"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                children: "Find A Store"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(customerReview, {}),
                        similertiles.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "pro_similartiles",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: "Similar Tiles"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(youMayAlso, {
                                    products: similertiles,
                                    UnbxdRecomendatoRequestID: UnbxdRecomendatoRequestID,
                                    widget: "WIDGET3"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pro_about",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: product.description.html
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "pro_about Pro_Other pdp-other-detail-row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: "Other Details"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "pdp-other-bx",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "pdp-label",
                                                    children: "Size: "
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "pdp-text-detail",
                                                    children: [
                                                        product.extraVariables.size ? product.extraVariables.size : "-",
                                                        " ",
                                                        "mm"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "pdp-label",
                                                    children: [
                                                        "Net Quantity (Tiles per box):",
                                                        " "
                                                    ]
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "pdp-text-detail",
                                                    children: [
                                                        product.extraVariables.tile_per_box ? product.extraVariables.tile_per_box : "-",
                                                        "N",
                                                        " "
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "pdp-label",
                                                    children: "Area: "
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "pdp-text-detail",
                                                    children: product.extraVariables.size && product.extraVariables.tile_per_box ? (()=>{
                                                        const sizeParts = product.extraVariables.size.split("x");
                                                        if (sizeParts.length === 2) {
                                                            const length = parseFloat(sizeParts[0].trim());
                                                            const width = parseFloat(sizeParts[1].trim());
                                                            const areaSqMm = length * width * product.extraVariables.tile_per_box; // Calculate area in sq mm
                                                            const areaSqDm = areaSqMm / 10000; // Convert area to sq dm
                                                            // console.log("9090", areaSqDm)
                                                            if (areaSqDm < 100) {
                                                                return "".concat(areaSqDm.toFixed(2), " sq Decimeter");
                                                            } else {
                                                                return "".concat((areaSqMm / 1000000).toFixed(2), " sq Meters");
                                                            }
                                                        } else {
                                                            return "Invalid size format";
                                                        }
                                                    })() : "-"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "pdp-label",
                                                    children: "Number of Faces: "
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "pdp-text-detail",
                                                    children: product.extraVariables.number_of_faces ? product.extraVariables.number_of_faces : "-"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "pdp-label",
                                                    children: "Factory"
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "pdp-text-detail",
                                                    children: product.extraVariables.factory == "Sikandrabad" ? "Regd. Office: 8, Industrial Area, Sikandrabad 203205, UP, India " : product.extraVariables.factory
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "pdp-label",
                                                    children: "Country of origin: "
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "pdp-text-detail",
                                                    children: "India"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "pdp-label",
                                                    children: [
                                                        "Recommended Laying Pattern:",
                                                        " "
                                                    ]
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "pdp-text-detail",
                                                    children: product.extraVariables.recommended_laying_patter ? product.extraVariables.recommended_laying_patter : "-"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        youmayalsolikee.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "pro_youmayalso",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "productpage_title",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "You May Also Like"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(youMayAlso, {
                                    products: youmayalsolikee,
                                    UnbxdRecomendatoRequestID: UnbxdRecomendatoRequestID,
                                    widget: "WIDGET1"
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                        throwConfetti && //         <Confetti
                        //         numberOfPieces={300}
                        //         tweenDuration={10}
                        //         width={width}
                        //         height={height}
                        //   colors={['#009444', '#ffca34']}
                        // style={{
                        //    zIndex: 9999,
                        //    position: 'fixed',
                        //    top: 0,
                        //    left: 0,
                        //    width: '100vw',
                        //    height: '100vh',
                        //  }}
                        // />
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Fireworks */.j, {
                            options: {
                                rocketsPoint: {
                                    min: 0,
                                    max: 100
                                }
                            },
                            style: {
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                position: "fixed"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "syte-shop-the-look-container",
                            "data-sku": product.sku,
                            "data-image-src": (ref29 = product.image) === null || ref29 === void 0 ? void 0 : ref29.url
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "pro_writereview",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: "Write A Review / Comment"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                        md: 6,
                                        xs: 12,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(addReview, {
                                                productId: product.id
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "pro_writereview_data",
                                                children: reviews.map((e, i)=>{
                                                    var ref;
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "pro_writereview_content",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "review_iden",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        src: "../review_dummy.png",
                                                                        alt: "image"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                        children: e.customer_name
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "review_rat"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stars/* default */.Z, {
                                                                count: 5,
                                                                value: e.rating,
                                                                edit: false,
                                                                color2: "#ff5e00",
                                                                style: {
                                                                    paddingRight: "5px"
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                                                                children: [
                                                                    " ",
                                                                    e.rating,
                                                                    " out of 5 stars "
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                                                                children: [
                                                                    "Post at ",
                                                                    e.created_at
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "review_com",
                                                                children: e.detail
                                                            }),
                                                            ((ref = e.review_image) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "review_images",
                                                                children: e.review_image.map((item, i)=>{
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        src: item.image_url,
                                                                        alt: "image"
                                                                    }, i);
                                                                })
                                                            })
                                                        ]
                                                    }, i);
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                show: getInTouch,
                className: "pincode-popup-bx expert_assistance_modal",
                onHide: ()=>{
                    setGetInTouch(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default.Dialog */.Z.Dialog, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                            closeButton: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Title */.Z.Title, {
                                style: {
                                    fontSize: "15px !important"
                                },
                                children: "We are unable to determine the pricing for your pincode . Kindly leave your details and we will get back to you to help you with your order."
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default */.Z, {
                                onSubmit: (e)=>{
                                    e.preventDefault();
                                    submitGetInTouch("Zerotransport Website ".concat(product.extraVariables.factory ? product.extraVariables.factory : ""));
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                        className: "mb-3",
                                        controlId: "formBasicEmail",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                                children: "Name"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                type: "text",
                                                placeholder: "Name*",
                                                onChange: (e)=>{
                                                    setTouch({
                                                        ...touch,
                                                        name: e.target.value
                                                    });
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                                        className: "mb-3",
                                        controlId: "formBasicPassword",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                                children: "Mobile"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                                type: "number",
                                                placeholder: "Mobile Number*",
                                                onChange: (e)=>{
                                                    setTouch({
                                                        ...touch,
                                                        number: e.target.value
                                                    });
                                                }
                                            })
                                        ]
                                    }),
                                    touch.error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "error text-danger",
                                        children: touch.error
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        variant: "primary",
                                        type: "submit",
                                        disabled: touch.loading,
                                        style: {
                                            width: "100%"
                                        },
                                        children: touch.loading ? "Submitting" : "Submit"
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _product_ = (Product);


/***/ }),

/***/ 35620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ convertPricePerSqmToSqft; }
/* harmony export */ });
/**
 * Converts a given price in price-per-square-meter to price-per-square-foot
 *
 * @param {number} pricePerSqm - Price per square meter
 * @returns {number} - Price per square foot
 */ function convertPricePerSqmToSqft(pricePerSqm) {
    const conversionFactor = 10.7639;
    return (pricePerSqm / conversionFactor).toFixed(0);
}


/***/ }),

/***/ 42480:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,7361,7767,5518,4585,7615,6212,2770,5063,6737,4471,7130,3372,9774,2888,179], function() { return __webpack_exec__(50341); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);